import { 
	DOCKET_PREFIX_FIELD, 
	SEQUENCE_NUM_FIELD, 
	FEE_OPTION_FIELD, 
	GENERAL_FILING_TYPE_FIELD, 
	CONFIRMATION_NUM_FIELD, 
	PRIMARY_RECORDATION_NUM_FIELD, 
	RECORDATION_OPTION_FIELD, 
	SUBMITTER_FIELD, 
	ADDRESS_ONE_FIELD,
	ADDRESS_TWO_FIELD, 
	CITY_FIELD, 
	STATE_FIELD, 
	ZIP_FIELD, 
	COUNTRY_FIELD, 
	PHONE_FIELD, 
	EMAIL_FIELD, 
	RECORDATION_DATE_OF_AGREEMENT_FIELD,
	EQUIPMENT_DESCRIPTION_FIELD, 
	SUBSEQUENCE_NUM_FIELD, FAX_FIELD, 
	ADDITIONAL_EMAIL_FIELD, 
	FORMAL_FILING_FORM_TYPE, 
	OTHER_FILING_FORM_TYPE, 
	RECORDATION_FORM_TYPE, 
	RECORDATION_TYPE_OF_AGREEMENT_FIELD, 
	COMPANY_FIELD, 
	RAILROADS_INVOLVED_FIELD,
	PROBLEM_LOCATION_FIELD,
	INDUSTRY_LOCATION_FIELD,
	PROBLEM_DATES_FIELD,
	ISSUE_SUMMARY_FIELD,
	ISSUE_FIELD,
	COMMODITY_GROUP_FIELD,
	REGION_FIELD,
	CONTACT_PERMISSION_FIELD,
	ENVCOM_PROJECT_FIELD,
	ENVCOM_ATTENTION_FIELD,
	ENVCOM_YOUR_NAME_FIELD,
	ENVCOM_AFFILIATION_FIELD,
	ENVCOM_COMMENTS_FIELD,
	ENVCOM_ORGANIZATION_FIELD,
	ENVCOM_HAVE_DOCKETS_FIELD
} from "./fields";

export const NULL_UNDEFINED_EMPTY = [null, undefined, ""];

export const hasValue = (value) => !NULL_UNDEFINED_EMPTY.includes(value);

export const MAX_FILE_SIZE_BYTES = 104857600;
export const MAX_FILE_SIZE_500MB_BYTES = 524288000;
export const MAX_FILE_NAME_LENGTH = 150;
export const MAX_EQUIPMENT_DESCRIPTION_LENGTH = 25000;
export const MAX_TEXT_AREA_DEFAULT_LENGTH = 25000;
export const MAX_PARTIES = 6;
export const MAX_ATTACHMENTS_FILING = 10;
export const MAX_ATTACHMENTS_RECORDATIONS = 1;
export const MAX_ATTACHMENTS_RCPA = 5;
export const MAX_ATTACHMENTS_ENVCOM = 4;
export const MAX_DOCKET_NUMBERS = 5;

export const PARTY_LIMITS = {
	[FORMAL_FILING_FORM_TYPE]: {
		max: 6,
		min: 1
	},
	[OTHER_FILING_FORM_TYPE]: {
		max: 6,
		min: 1
	},
	[RECORDATION_FORM_TYPE]: {
		max: 12, //TBD
		min: 1
	}
}

export const IS_IE11 = !!window.MSInputMethodContext && !!document.documentMode;
export const DATE_PLACEHOLDER = "mm/dd/yyyy";

export const PDF_CAPS = 'PDF';

export const FIELDS_TO_VALIDATE_EMAIL = [
	EMAIL_FIELD,
	ADDITIONAL_EMAIL_FIELD
];

export const FIELDS_TO_VALIDATE_IS_NUMBER = [
	SEQUENCE_NUM_FIELD,
	SUBSEQUENCE_NUM_FIELD
];

export const PHONE_FIELDS = [
	PHONE_FIELD,
	FAX_FIELD
]

export const EFILING_FIELDS_TO_VALIDATE = [
	DOCKET_PREFIX_FIELD,
	SEQUENCE_NUM_FIELD,
	FEE_OPTION_FIELD,
	CONFIRMATION_NUM_FIELD
];

export const INFORMAL_FIELDS_TO_VALIDATE = [
	DOCKET_PREFIX_FIELD,
	SEQUENCE_NUM_FIELD,
	GENERAL_FILING_TYPE_FIELD
];

export const RECORDATION_FIELDS_TO_VALIDATE = [
	RECORDATION_OPTION_FIELD,
	PRIMARY_RECORDATION_NUM_FIELD,
	CONFIRMATION_NUM_FIELD,
	SUBMITTER_FIELD,
	COMPANY_FIELD,
	ADDRESS_ONE_FIELD,
	CITY_FIELD,
	STATE_FIELD,
	ZIP_FIELD,
	COUNTRY_FIELD,
	PHONE_FIELD,
	EMAIL_FIELD,
	RECORDATION_DATE_OF_AGREEMENT_FIELD,
	RECORDATION_TYPE_OF_AGREEMENT_FIELD,
	EQUIPMENT_DESCRIPTION_FIELD
];

export const RCPA_FIELDS_TO_VALIDATE = [
	SUBMITTER_FIELD,
	PHONE_FIELD,
	EMAIL_FIELD,
	ISSUE_FIELD,
	COMMODITY_GROUP_FIELD,
	REGION_FIELD,
	ISSUE_SUMMARY_FIELD,
	CONTACT_PERMISSION_FIELD
];

export const RCPA_FIELD_LENGTHS = {
	[PHONE_FIELD] : 255,
	[FAX_FIELD] : 100,
	[RAILROADS_INVOLVED_FIELD] : 500,
	[PROBLEM_LOCATION_FIELD] : 500,
	[INDUSTRY_LOCATION_FIELD] : 500,
	[PROBLEM_DATES_FIELD] : 500,
	[ISSUE_SUMMARY_FIELD] : 2000
}

export const ENVIRONMENTAL_COMMENTS_FIELDS_TO_VALIDATE = [
	ENVCOM_HAVE_DOCKETS_FIELD,
	DOCKET_PREFIX_FIELD,
	SEQUENCE_NUM_FIELD,
	ENVCOM_PROJECT_FIELD,
	ENVCOM_ATTENTION_FIELD,
	ENVCOM_YOUR_NAME_FIELD,
	ENVCOM_AFFILIATION_FIELD,
	ADDRESS_ONE_FIELD,
	CITY_FIELD,
	STATE_FIELD,
	ZIP_FIELD,
	COUNTRY_FIELD,
	EMAIL_FIELD
];

export const ENV_COM_FIELD_LENGTHS = {
	[ENVCOM_PROJECT_FIELD] : 255,
	[ENVCOM_YOUR_NAME_FIELD] : 255,
	[ENVCOM_ORGANIZATION_FIELD] : 255,
	[ADDRESS_ONE_FIELD] : 255,
	[ADDRESS_TWO_FIELD] : 255,
	[CITY_FIELD] : 255,
	[STATE_FIELD] : 100,
	[ZIP_FIELD] : 10,
	[PHONE_FIELD] : 255,
	[EMAIL_FIELD] : 255,
	[ENVCOM_COMMENTS_FIELD] : 2000
}

export const VALID_ERECORDATION_FILE_TYPES = [
	"doc",
	"docx",
	"xls",
	"xlsx",
	"pdf",
	"gif",
	"jpg",
	"jpeg",
	"png",
	"mpg",
	"mpeg",
	"avi",
	"mov",
	"zip"
];

export const VALID_EFILING_FILE_TYPES = [
	...VALID_ERECORDATION_FILE_TYPES,
	"csv"
];

export const VALID_EFILING_FORMAL_FILE_TYPES = [
	...VALID_EFILING_FILE_TYPES,
	"kml",
	"kmz",
	"cpg",
	"dbf",
	"prj",
	"shp",
	"shx"
];

export const VALID_EFILING_ENV_COMM_FILE_TYPES = [
	...VALID_EFILING_FILE_TYPES,
	"kml",
	"kmz"
];

// Information taken from:
//   https://en.wikipedia.org/wiki/List_of_file_signatures
//   https://www.filesignatures.net/index.php?page=all
export const FILE_MIME_TYPES = [
	{ signature: "0000000C6A502020", byteLength: 8, fileTypes: ["jp2"] },
	{ signature: "0000001466747970", byteLength: 8, fileTypes: ["3gp"] },
	{ signature: "0000001866747970", byteLength: 8, fileTypes: ["3gp5"] }, //mpeg-4
	{ signature: "0000002066747970", byteLength: 8, fileTypes: ["3gp"] },
	{ signature: "000001B3", byteLength: 4, fileTypes: ["mpg", "mpeg"] },
	{ signature: "000001BA", byteLength: 4, fileTypes: ["mpg", "vob"] },
	{ signature: "006E1EF0", byteLength: 4, fileTypes: ["ppt"] },
	{ signature: "0908100000060500", byteLength: 8, fileTypes: ["xls"] },
	{ signature: "0F00E803", byteLength: 4, fileTypes: ["ppt"] },
	{ signature: "1F8B", byteLength: 2, fileTypes: ["gz"] }, //gz, tar.gz
	{ signature: "1F8B08", byteLength: 3, fileTypes: ["gz"] }, //gz, tar.gz
	{ signature: "1F9D", byteLength: 2, fileTypes: ["z"] }, //z, tar.z
	{ signature: "1F9D90", byteLength: 3, fileTypes: ["z"] }, //z, tar.z
	{ signature: "1FA0", byteLength: 2, fileTypes: ["z"] }, //z, tar.z
	{ signature: "25504446", byteLength: 4, fileTypes: ["pdf", "fdf"] },
	{
		signature: "3026B2758E66CF11",
		byteLength: 8,
		fileTypes: ["asf", "wma", "wmv"]
	},
	{ signature: "377ABCAF271C", byteLength: 6, fileTypes: ["7z"] }, //7zip
	{ signature: "3C3F786D6C20", byteLength: 6, fileTypes: ["kml", "xml"] },
	{ signature: "424D", byteLength: 2, fileTypes: ["bmp", "dib"] },
	{ signature: "425A68", byteLength: 3, fileTypes: ["bz2", "tb2", "tbz2"] }, //bz2, tar.bz2, tb2, tbz2
	{ signature: "47494638", byteLength: 4, fileTypes: ["gif"] },
	{ signature: "492094", byteLength: 3, fileTypes: ["tif", "tiff"] },
	{ signature: "494433", byteLength: 3, fileTypes: ["mp3"] },
	{ signature: "49492A00", byteLength: 4, fileTypes: ["tif", "tiff"] },
	{ signature: "4A4152435300", byteLength: 6, fileTypes: ["jar"] },
	{ signature: "4D4D002A", byteLength: 4, fileTypes: ["tif", "tiff"] },
	{ signature: "4D4D002B", byteLength: 4, fileTypes: ["tif", "tiff"] },
	{ signature: "4D534346", byteLength: 4, fileTypes: ["ppz"] }, //packaged ppt
	{ signature: "4C5A4950", byteLength: 4, fileTypes: ["lz"] }, //lzip
	{
		signature: "4D5A",
		byteLength: 2,
		fileTypes: ["com", "dll", "exe", "fon", "sys"]
	}, //executable file (generally, avoid these files)
	{ signature: "50350A", byteLength: 3, fileTypes: ["pgm"] },
	{
		signature: "504B0304",
		byteLength: 4,
		fileTypes: [
			"zip",
			"aar",
			"apk",
			"zuix",
			"docx",
			"epub",
			"ipa",
			"jar",
			"kmz",
			"kwd",
			"maff",
			"odp",
			"ods",
			"odt",
			"ott",
			"pk3",
			"pk4",
			"pptx",
			"sxc",
			"sxd",
			"sxi",
			"sxw",
			"usdz",
			"vsdx",
			"wmz",
			"xlsx",
			"xpi",
			"xps"
		]
	},
	{ signature: "504B030414000100", byteLength: 8, fileTypes: ["zip"] },
	{
		signature: "504B030414000600",
		byteLength: 8,
		fileTypes: ["docx", "pptx", "xlsx"]
	}, //MS Office 2007
	{ signature: "504B030414000800", byteLength: 8, fileTypes: ["jar"] },
	{ signature: "504B0506", byteLength: 4, fileTypes: ["zip"] }, //empty archinve
	{ signature: "504B0708", byteLength: 4, fileTypes: ["zip"] }, //split archive
	{ signature: "504B4C495445", byteLength: 6, fileTypes: ["zip"] }, //pklite zip
	{ signature: "504B537058", byteLength: 5, fileTypes: ["zip"] }, //pksfx self-extracting zip
	{
		signature: "52494646",
		byteLength: 4,
		fileTypes: [
			"4xm",
			"ani",
			"avi",
			"cda",
			"cdr",
			"cmx",
			"dat",
			"ds4",
			"qcp",
			"rmi",
			"wav"
		]
	},
	{ signature: "526172211A0700", byteLength: 7, fileTypes: ["rar"] }, //rar v. 1.50+
	{ signature: "526172211A070100", byteLength: 8, fileTypes: ["rar"] }, //rar v. 5.0+
	{ signature: "53434D49", byteLength: 4, fileTypes: ["img"] },
	{ signature: "5349542100", byteLength: 5, fileTypes: ["sit"] }, //stuffit archive
	{ signature: "5374756666497420", byteLength: 8, fileTypes: ["sit"] },
	{ signature: "554641C6D2C1", byteLength: 5, fileTypes: ["ufa"] }, //ufa archive
	{ signature: "57696E5A6970", byteLength: 6, fileTypes: ["zip"] },
	{ signature: "5F27A889", byteLength: 4, fileTypes: ["jar"] },
	{ signature: "60EA", byteLength: 2, fileTypes: "arj" }, //ARJ archive
	{ signature: "6D646174", byteLength: 4, fileTypes: ["mov"] },
	{ signature: "6D6F6F76", byteLength: 4, fileTypes: ["mov"] },
	{ signature: "706E6F74", byteLength: 4, fileTypes: ["mov"] },
	{ signature: "727473703A2F2F", byteLength: 7, fileTypes: ["ram"] },
	{ signature: "736B6970", byteLength: 4, fileTypes: ["mov"] },
	{ signature: "7573746172", byteLength: 5, fileTypes: ["tar"] },
	{ signature: "7573746172003030", byteLength: 8, fileTypes: ["tar"] },
	{ signature: "7573746172202000", byteLength: 8, fileTypes: ["tar"] },
	{ signature: "77696465", byteLength: 4, fileTypes: ["mov"] },
	{ signature: "78617221", byteLength: 4, fileTypes: ["xar"] },
	{ signature: "7801", byteLength: 2, fileTypes: ["zlib"] },
	{ signature: "789C", byteLength: 2, fileTypes: ["zlib"] },
	{ signature: "78DA", byteLength: 2, fileTypes: ["zlib"] },
	{ signature: "7B5C72746631", byteLength: 6, fileTypes: ["rtf"] },
	{ signature: "89504E470D0A1A0A", byteLength: 8, fileTypes: ["png"] },
	{ signature: "A0461DF0", byteLength: 4, fileTypes: ["ppt"] },
	{
		signature: "D0CF11E0A1B11AE1",
		byteLength: 8,
		fileTypes: ["doc", "xls", "ppt"]
	},
	{ signature: "DBA52D00", byteLength: 4, fileTypes: ["doc"] },
	{ signature: "E8", byteLength: 1, fileTypes: ["com", "sys"] },
	{ signature: "E9", byteLength: 1, fileTypes: ["com", "sys"] },
	{ signature: "EB", byteLength: 1, fileTypes: ["com", "sys"] },
	{ signature: "ECA5C100", byteLength: 4, fileTypes: ["doc"] },
	{ signature: "FD377A585A0000", byteLength: 7, fileTypes: ["xz"] }, //xz, tar.xz
	{ signature: "FDFFFFFF0E000000", byteLength: 8, fileTypes: ["ppt"] },
	{ signature: "FDFFFFFF10", byteLength: 5, fileTypes: ["xls"] },
	{ signature: "FDFFFFFF1C000000", byteLength: 8, fileTypes: ["ppt"] },
	{ signature: "FDFFFFFF1F", byteLength: 5, fileTypes: ["xls"] },
	{ signature: "FDFFFFFF22", byteLength: 5, fileTypes: ["xls"] },
	{ signature: "FDFFFFFF23", byteLength: 5, fileTypes: ["xls"] },
	{ signature: "FDFFFFFF28", byteLength: 5, fileTypes: ["xls"] },
	{ signature: "FDFFFFFF29", byteLength: 5, fileTypes: ["xls"] },
	{ signature: "FDFFFFFF43000000", byteLength: 8, fileTypes: ["ppt"] },
	{ signature: "FFD8FFDB", byteLength: 4, fileTypes: ["jpg", "jpeg"] },
	{
		signature: "FFD8FFE0",
		byteLength: 4,
		fileTypes: ["jpe", "jpeg", "jfif", "jpg"]
	},
	{ signature: "FFD8FFE1", byteLength: 4, fileTypes: ["jpg", "jpeg"] },
	{ signature: "FFD8FFE2", byteLength: 4, fileTypes: ["jpeg"] },
	{ signature: "FFD8FFE8", byteLength: 4, fileTypes: ["jpg"] },
	{ signature: "FFD8FFEE", byteLength: 4, fileTypes: ["jpg", "jpeg"] },
	{ signature: "FFFB", byteLength: 2, fileTypes: ["mp3"] }
	// {signature: '', byteLength: 0, fileTypes: ['']}
];
